import React from 'react'
import { HomeFilterForm } from '../containers/HomeFiltersForm'
import StudiKWListing from '../containers/StudiKwListing'
import { FilterDataProvider } from '../HOC/studiKwFiltersContext'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

export default function Home() {
  SetTitle('Rank Inspector')
  return (
    <FilterDataProvider>
      <Header
        iconClass="fa-solid fa-house-chimney fa-xl"
        title="Rank Inspector"
        docLink="/docs/ranking_tools/studi-keywords/"
        headerClassName="main-page-title"
        headerChildren={<HomeFilterForm />}
      >
        <StudiKWListing />
      </Header>
    </FilterDataProvider>
  )
}